import React, {useEffect, useState} from "react"
import theme from "./../../../Theme/Theme"
import { Div, Text, Tag, Icon } from "atomize";
import styled from "styled-components";
import {apiGet} from "../../../Api";
import {Link, withRouter} from "react-router-dom";
import {removeActivity} from "../../../redux/actions";
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import truncateElipse from "./../../../utils/truncateElipse";

const Wrapper = styled(Tag)`
  font-family: Inter;	
  font-size: 12px;	
  font-weight: 600;	
  line-height: 20px;
  
  &:hover {
    opacity: .95;
  }
`;

const StyledLink = styled(Link)`

`;

function ActivityChip(props) {
  const [data, setData] = useState(null);
  useEffect(() => {
    async function fetchData() {
      const result = await apiGet(`/node/activity/${props.id}?include=field_experience_layer&jsonapi_include=1`);
      setData(result.data.data);
    }
    fetchData();
  }, []);

  if (!props.dismissable) {
    return (
      <>
        {
          data &&
          <StyledLink
            to={ '/activities/' + encodeURIComponent(data.title.toLowerCase())}
          >
            <Wrapper
              bg={data.field_experience_layer.field_color ? data.field_experience_layer.field_color.color + '1A' : null}
              border="1px solid"
              borderColor={data.field_experience_layer.field_color ? data.field_experience_layer.field_color.color + '26' : null}
              textColor={theme.colors.dark}
              m={{ r: "0.5rem", b: "0.5rem" }}
              shadow={'1'}
            >
              { truncateElipse(data.title, 35) }
            </Wrapper>
          </StyledLink>
        }

      </>
    )
  } else {
    return (
      <>
        {
          data &&
          <Wrapper
            bg={data.field_experience_layer.field_color.color + '1A'}
            border="1px solid"
            borderColor={data.field_experience_layer.field_color.color + '26'}
            textColor={theme.colors.dark}
            m={{ r: "0.5rem", b: "0.5rem" }}
            shadow={'1'}

            suffix={
              <Icon
                name="Cross"
                size="14px"
                m={{ l: "5px" }}
                cursor="pointer"
                role={"link"}
                aria-label={"remove activity"}
                onClick={() => props.removeActivity(data)}
              />
            }
          >
            { data.title }
          </Wrapper>
        }

      </>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      removeActivity: removeActivity
    },
    dispatch
  );
};

export default withRouter(connect(
  null,
  mapDispatchToProps
)(ActivityChip));

